<app-select
  [items]="timezoneItems"
  [control]="timezoneControl"
  [enableTypeahead]="true"
  [labelKey]="timezoneLabel"
  (onChange)="enableSave.emit()">
</app-select>
<mat-list>
  <div mat-subheader class="md-subheader" translate="account/business-hours/every-week"></div>
  <mat-list-item *ngFor="let control of weekControl.controls; let i = index">
    <div mat-line class="week-line">
      <div [translate]="daysOfWeek[weekControl.controls[i].value.id]"></div>
      <div>
        <span translate="account/business-hours/start"></span>&nbsp;
        {{ formatTime(weekControl.controls[i].value.start) }}
      </div>
      <div>
        <span translate="account/business-hours/end"></span>&nbsp;
        {{ formatTime(weekControl.controls[i].value.end) }}
      </div>
      <div>
        <mat-icon color="primary" (click)="editWeekDay(i)">edit</mat-icon>
        <mat-icon color="primary" (click)="deleteWeekDay(i)">delete</mat-icon>
      </div>
    </div>
  </mat-list-item>
  <button
    class="add-button"
    type="button"
    mat-raised-button
    color="primary"
    (click)="addWeekDay()"
    translate="account/business-hours/add"></button>
  <div mat-subheader class="md-subheader" translate="account/business-hours/exceptions"></div>
  <mat-list-item *ngFor="let control of exceptionsControl.controls; let i = index">
    <div mat-line class="week-line">
      <!-- date without time, entered by user, do not use pipe dateTimezone -->
      <div>{{ exceptionsControl.controls[i].value.date | date }}</div>

      <span
        class="closed"
        *ngIf="
          !exceptionsControl.controls[i].value.start.h &&
            !exceptionsControl.controls[i].value.end.h &&
            !exceptionsControl.controls[i].value.start.m &&
            !exceptionsControl.controls[i].value.end.m;
          else hours
        "
        translate="account/business-hours/closed"></span>

      <ng-template #hours>
        <div>
          <span translate="account/business-hours/start"></span>&nbsp;
          {{ formatTime(exceptionsControl.controls[i].value.start) }}
        </div>
        <div>
          <span translate="account/business-hours/end"></span>&nbsp;
          {{ formatTime(exceptionsControl.controls[i].value.end) }}
        </div>
      </ng-template>
      <div>
        <mat-icon color="primary" (click)="editException(i)">edit</mat-icon>
        <mat-icon color="primary" (click)="deleteException(i)">delete</mat-icon>
      </div>
    </div>
  </mat-list-item>
  <button
    class="add-button"
    type="button"
    mat-raised-button
    color="primary"
    (click)="addException()"
    translate="account/business-hours/add"></button>
</mat-list>

<ng-template #modifyBusinessHoursTemplateRef>
  <form [formGroup]="weekDayForm">
    <app-select [labelKey]="dayLabel" [control]="$any(weekDayForm.get('id'))" [items]="daysOfWeekItems"> </app-select>
    <div class="business-hours">
      <span translate="account/business-hours/week/edit/start"></span>
      <ngx-mat-timepicker-field
        (timeChanged)="updateHours($event, weekDayForm, 'start')"
        [format]="24"
        [defaultTime]="startHours"></ngx-mat-timepicker-field>
    </div>

    <div class="business-hours">
      <span translate="account/business-hours/week/edit/end"></span>
      <ngx-mat-timepicker-field
        (timeChanged)="updateHours($event, weekDayForm, 'end')"
        [format]="24"
        [defaultTime]="endHours"></ngx-mat-timepicker-field>
    </div>
    <mat-error
      *ngIf="weekDayForm.hasError('incoherent')"
      translate="account/business-hours/edit/incoherent"></mat-error>
  </form>
</ng-template>

<ng-template #modifyExceptionTemplateRef>
  <form [formGroup]="exceptionForm">
    <p>
      <mat-form-field appearance="fill">
        <mat-label translate="account/business-hours/exception/edit/date"></mat-label>
        <input matInput formControlName="date" [matDatepicker]="picker" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </p>

    <p>
      <mat-slide-toggle
        color="primary"
        [(ngModel)]="closed"
        [ngModelOptions]="{ standalone: true }"
        translate="account/business-hours/open">
      </mat-slide-toggle>
    </p>

    <ng-container *ngIf="!closed">
      <div class="business-hours">
        <span translate="account/business-hours/week/edit/start"></span>
        <ngx-mat-timepicker-field
          (timeChanged)="updateHours($event, exceptionForm, 'start')"
          [format]="24"
          [defaultTime]="startHours"></ngx-mat-timepicker-field>
      </div>

      <div class="business-hours">
        <span translate="account/business-hours/week/edit/end"></span>
        <ngx-mat-timepicker-field
          (timeChanged)="updateHours($event, exceptionForm, 'end')"
          [format]="24"
          [defaultTime]="endHours"></ngx-mat-timepicker-field>
      </div>
    </ng-container>
    <mat-error
      *ngIf="exceptionForm.hasError('incoherent')"
      translate="account/business-hours/edit/incoherent"></mat-error>
  </form>
</ng-template>
